import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';

const AccountSettings = () => {
    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem('user'));

    const [currentPassword, setCurrentPassword] = useState('');
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!newUsername.trim() && !newPassword.trim()) {
            setError('Unesite novo korisničko ime i/ili novu lozinku.');
            return;
        }
        if (newPassword && newPassword !== confirmPassword) {
            setError('Nova lozinka i potvrda lozinke se ne poklapaju.');
            return;
        }

        setSaving(true);
        try {
            await API.put('/account/change-credentials', {
                currentPassword,
                newUsername: newUsername.trim() || null,
                newPassword: newPassword.trim() || null
            });

            alert('Podaci uspešno promenjeni. Prijavite se ponovo.');
            sessionStorage.clear();
            navigate('/login');
        } catch (err) {
            setError(err.response?.data?.message || 'Greška pri čuvanju izmena.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Moj nalog</h2>
            <p style={styles.hint}>
                Trenutno korisničko ime: <strong>{user?.username}</strong>. Popunite samo ono što želite da promenite -
                korisničko ime, lozinku, ili oboje. Posle uspešne izmene bićete odjavljeni i moraćete ponovo da se prijavite.
            </p>

            <form onSubmit={handleSubmit} style={styles.form}>
                <label style={styles.label}>Trenutna lozinka (obavezno)</label>
                <input
                    type="password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    style={styles.input}
                    required
                />

                <label style={styles.label}>Novo korisničko ime (opciono)</label>
                <input
                    type="text"
                    value={newUsername}
                    onChange={(e) => setNewUsername(e.target.value)}
                    style={styles.input}
                    placeholder={user?.username}
                />

                <label style={styles.label}>Nova lozinka (opciono)</label>
                <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={styles.input}
                />

                {newPassword && (
                    <>
                        <label style={styles.label}>Potvrdi novu lozinku</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            style={styles.input}
                        />
                    </>
                )}

                {error && <p style={styles.error}>{error}</p>}

                <button type="submit" style={{ ...styles.saveBtn, opacity: saving ? 0.6 : 1 }} disabled={saving}>
                    {saving ? 'Čuvanje...' : 'Sačuvaj izmene'}
                </button>
            </form>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '450px',
        margin: '40px auto',
        padding: '30px',
        background: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    title: { margin: '0 0 10px 0', fontSize: '24px', color: '#1f2937', textAlign: 'center' },
    hint: { fontSize: '13px', color: '#7f8c8d', marginBottom: '20px', lineHeight: '1.5' },
    form: { display: 'flex', flexDirection: 'column' },
    label: { display: 'block', marginBottom: '6px', marginTop: '14px', fontWeight: '600', color: '#475569', fontSize: '13px' },
    input: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '15px', outline: 'none', boxSizing: 'border-box' },
    error: { color: '#e74c3c', fontSize: '13px', marginTop: '14px' },
    saveBtn: { marginTop: '20px', width: '100%', padding: '14px', background: '#1c8aa6', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '15px', fontWeight: 'bold' }
};

export default AccountSettings;
